
import { defineComponent, ref } from "vue";
import SearchInput from "@/components/common/SearchInput.vue";
import Grid from "@moonlight/vue3/components/Grid.vue";
import { trans } from "@/globals/translator";
export default defineComponent({
  components: {
    SearchInput,
    Grid,
  },
  setup() {
    const searchQuery = ref();
    return {
      trans,
      searchQuery,
    };
  },
  methods: {
    goToSearchPage() {
      this.$router.push({
        name: "Search",
        query: {
          q: this.searchQuery,
        },
      });
    },
  },
});
